import { Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector:    'app-system-configuration',
  templateUrl: './system-configuration.component.html',
  styles:   [],
  imports:     [
    MatTabNav,
    TranslatePipe,
    RouterLink,
    MatTabLink,
    MatTabNavPanel,
    RouterOutlet
  ],
  standalone:  true
})
export class SystemConfigurationComponent {
  constructor(private router: Router) {
  }

  public isActive(route: string): boolean {
    return this.router.isActive('system-configuration/' + route, false);
  }
}
